export class ItemsProspecto {
    idItemsProspecto: number;
    Nombre_Item: string;
    Descripcion_Item: string;
    Estado: string;
    checked: boolean;
    placeholderItem?: string;
    Observaciones:string;
}